import React, { useState, useEffect } from 'react';

const IconDebug = () => {
  const [fontAwesomeLoaded, setFontAwesomeLoaded] = useState(false);
  const [testResults, setTestResults] = useState([]);

  useEffect(() => {
    // Check if Font Awesome CSS is loaded
    const checkFontAwesome = () => {
      const testElement = document.createElement('i');
      testElement.className = 'fas fa-home';
      testElement.style.position = 'absolute';
      testElement.style.left = '-9999px';
      document.body.appendChild(testElement);
      
      const computedStyle = window.getComputedStyle(testElement, '::before');
      const content = computedStyle.content;
      
      document.body.removeChild(testElement);
      
      setFontAwesomeLoaded(content !== 'none' && content !== '');
      
      // Test specific icons
      const iconsToTest = [
        'fas fa-home',
        'fas fa-user',
        'fas fa-calendar',
        'fas fa-map-marker-alt',
        'fas fa-clock',
        'fas fa-phone',
        'fas fa-envelope',
        'fas fa-share-alt',
        'fas fa-external-link-alt',
        'fas fa-chevron-left',
        'fas fa-chevron-right',
        'fas fa-users',
        'fas fa-comment',
        'fas fa-facebook',
        'fas fa-twitter',
        'fas fa-instagram'
      ];
      
      const results = iconsToTest.map(iconClass => {
        const testEl = document.createElement('i');
        testEl.className = iconClass;
        testEl.style.position = 'absolute';
        testEl.style.left = '-9999px';
        document.body.appendChild(testEl);
        
        const style = window.getComputedStyle(testEl, '::before');
        const iconContent = style.content;
        const iconFont = style.fontFamily;
        
        document.body.removeChild(testEl);
        
        return {
          icon: iconClass,
          loaded: iconContent !== 'none' && iconContent !== '',
          content: iconContent,
          fontFamily: iconFont
        };
      });
      
      setTestResults(results);
    };
    
    checkFontAwesome();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2>Font Awesome Debug Information</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Font Awesome Status:</h3>
        <p>
          <strong>Font Awesome Loaded:</strong> 
          <span style={{ color: fontAwesomeLoaded ? 'green' : 'red', marginLeft: '10px' }}>
            {fontAwesomeLoaded ? '✅ Yes' : '❌ No'}
          </span>
        </p>
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Icon Test Results:</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '10px' }}>
          {testResults.map((result, index) => (
            <div 
              key={index} 
              style={{ 
                padding: '10px', 
                border: '1px solid #ddd', 
                borderRadius: '5px',
                backgroundColor: result.loaded ? '#e8f5e8' : '#ffe8e8'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <i className={result.icon} style={{ fontSize: '20px' }}></i>
                <span>{result.icon}</span>
                <span style={{ color: result.loaded ? 'green' : 'red' }}>
                  {result.loaded ? '✅' : '❌'}
                </span>
              </div>
              <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                Content: {result.content}<br/>
                Font: {result.fontFamily}
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div style={{ marginTop: '30px' }}>
        <h3>Manual Icon Test:</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '10px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <i className="fas fa-home" style={{ fontSize: '24px', color: 'blue' }}></i>
            <span>Home</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <i className="fas fa-user" style={{ fontSize: '24px', color: 'green' }}></i>
            <span>User</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <i className="fas fa-calendar" style={{ fontSize: '24px', color: 'red' }}></i>
            <span>Calendar</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <i className="fas fa-map-marker-alt" style={{ fontSize: '24px', color: 'orange' }}></i>
            <span>Map Marker</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <i className="fas fa-clock" style={{ fontSize: '24px', color: 'purple' }}></i>
            <span>Clock</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <i className="fas fa-phone" style={{ fontSize: '24px', color: 'teal' }}></i>
            <span>Phone</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <i className="fas fa-envelope" style={{ fontSize: '24px', color: 'brown' }}></i>
            <span>Email</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <i className="fas fa-share-alt" style={{ fontSize: '24px', color: 'pink' }}></i>
            <span>Share</span>
          </div>
        </div>
      </div>
      
      <div style={{ marginTop: '30px' }}>
        <h3>Troubleshooting Steps:</h3>
        <ol>
          <li>Check if Font Awesome CSS is properly loaded in the browser's Network tab</li>
          <li>Verify that the Font Awesome font files are accessible</li>
          <li>Check for any CSS conflicts that might override Font Awesome styles</li>
          <li>Ensure the correct Font Awesome version is being used</li>
          <li>Check browser console for any errors related to font loading</li>
        </ol>
      </div>
    </div>
  );
};

export default IconDebug; 